import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import "./styles.css";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import NextAction from "../../utils/NextAction";

export default function Controls({ controls }) {
  const {
    xQuaternion,
    yQuaternion,
    zQuaternion,
    angleQuaternion,
    setXQuaternion,
    setYQuaternion,
    setZQuaternion,
    setAngleQuaternion,
  } = controls;

  return (
    <div className="controls">
      <div className="controlGroup">
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Quaternion
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          Quaternion is a fantastic to represent rotation. I will only tell how
          to use it and not tell the mathematical principle here. If you are
          interested about the principle, check{" "}
          <a href={"https://www.youtube.com/watch?v=d4EgbgTm0Bg"}>this video</a>
          .
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Using Quaternion for rotation, there are only two things you have to
          determine. <br /> 1. The vector of the axis of rotation. <br />
          2. The rotation angle. <br />
          The dark axes "O'-xyz'" are the rotated frame axes and the black axis
          is the reference axis of rotation.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <div className="control">
              <Latex>$x$</Latex>
              <input
                value={xQuaternion}
                onChange={(e) => setXQuaternion(e.target.value)}
                step={1 / 32}
                type="number"
              />
            </div>
            <div className="control">
              <Latex>$y$</Latex>
              <input
                value={yQuaternion}
                onChange={(e) => setYQuaternion(e.target.value)}
                step={1 / 32}
                type="number"
              />
            </div>
            <div className="control">
              <Latex>$z$</Latex>
              <input
                value={zQuaternion}
                onChange={(e) => setZQuaternion(e.target.value)}
                step={1 / 32}
                type="number"
              />
            </div>
          </Box>
          <div className="control">
            <Latex>$\theta$ (degree)</Latex>
            <input
              value={angleQuaternion}
              onChange={(e) => setAngleQuaternion(e.target.value)}
              step={1}
              type="number"
            />
          </div>
        </Box>
      </div>
      <Latex>
        With this parameters, we can get the unit quaternion:
        {` $$q = cos\\frac{\\theta}{2} +  \\textbf{u}sin\\frac{\\theta}{2} $$`}
        {` $$\\textbf{u} = \\frac{x\\textbf{i} + y\\textbf{j} + z\\textbf{k}}{\\sqrt{x^2+y^2+x^2}} $$`}
        For the original $p$ vector which you want to rotate, the rotated result
        is
        {` $$p'= qpq^\{-1\}$$`}
      </Latex>
      <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
        If you want to understand the magic of quaternion, please check{" "}
        <a href={"https://www.youtube.com/watch?v=d4EgbgTm0Bg"}>this video</a>.
      </Typography>
      <NextAction
        label={"Next: Transformation"}
        to="/homogeneous-transformations"
      />
    </div>
  );
}
